<template>

    <!-- <el-card class="main-content">
        <el-table ref="supplierTable" :data="filteredSuppliers" border stripe
            :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }" @row-click="handleRowClick"
            height="60vh">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" type="index" width="55" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" align="center"></el-table-column>
            <el-table-column prop="contactInfo" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="address" label="供应商地址" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" width="105">
                <template #default="scope">
                    <el-tag :type="statusTypeMap[scope.row.status]">
                        {{ formatStatus(scope.row.status) }}
                    </el-tag>
                </template>
</el-table-column>

</el-table>

</el-card> -->
    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">供应商管理</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">供应商名称</div>
                    <div class="header-item">联系电话</div>
                    <div class="header-item">供应商地址</div>
                    <div class="header-item">状态</div>




                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in filteredSuppliers" :key="index">
                            <div class="body-item">{{ item.supplierName }}</div>
                            <div class="body-item">{{ item.contactInfo }}</div>
                            <div class="body-item">{{ item.address }}</div>
                            <div class="body-item"> {{ formatStatus(item.status) }}</div>


                        </div>
                        <div class="empty-tip" v-if="filteredSuppliers.length === 0">
                            暂无信息
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import {
    getSupplierList,
    add,

    edit,

    getSupplyMaterials,

} from "@/api/supplier";

export default {
    data() {
        return {
            previewPhotoVisible: false,
            previewPhotoUrl: "",
            Listdish: [],
            // 图片本地存储
            dishLocalFiles: [],
            localFiles: { file1: null, file2: null },
            // 搜索表单
            searchForm: { supplierName: "", status: "" },
            statusTypeMap: { 0: "success", 1: "danger" },
            // 列表与分页
            pagedSuppliers: [],
            filteredSuppliers: [],
            currentPage: 1,
            pageSize: 10,
            // 统计数据
            totalCount: 0,
            activeCount: 0,
            totalDishCount: 0,
            monthlyNewCount: 0,
            // 弹窗状态
            formVisible: false,
            previewImageVisible: false,
            isEditMode: false,
            addDishVisible: false,
            addQualificationVisible: false,
            viewQualificationVisible: false,
            detailDrawerVisible: false,
            editDishVisible: false,  // 编辑物料弹窗状态
            // 操作标识
            currentSupplierId: "",
            replacingFileType: "",
            // 图片预览
            previewImageUrl: "",
            previewImageTitle: "",
            // 表单数据
            supplierForm: {
                supplierName: "",
                contactInfo: "",
                address: "",
                status: "",
                dishes: []
            },
            qualificationForm: {
                supplierId: "",
                file1: "",
                file2: ""
            },
            viewQualificationData: {
                supplierId: "",
                file1: "",
                file2: "",
                file1Origin: "",
                file2Origin: ""
            },
            // 编辑物料表单数据
            editDishForm: {
                id: "",
                supplierId: "",
                bomName: "",
                unit: "",
                price: null,
                imageUrl: "",
                oldImageUrl: ""
            },
            editDishLocalFile: null,  // 编辑时选择的新图片

        };
    },

    mounted() {
        this.getList();
    },

    methods: {
        // ---------------------- 基础列表功能 ----------------------
        getList() {
            getSupplierList({ userId: localStorage.getItem("userId") })
                .then((response) => {
                    this.pagedSuppliers = response.data || [];
                    this.filteredSuppliers = [...this.pagedSuppliers];
                    this.calculateStats();
                })
                .catch((error) => {
                    console.error("获取供应商列表失败:", error);
                    this.$message.error("获取数据失败，请重试");
                });
        },

        calculateStats() {
            this.totalCount = this.filteredSuppliers.length;
            this.activeCount = this.filteredSuppliers.filter((s) => s.status === "0").length;
            this.totalDishCount = this.filteredSuppliers.reduce(
                (sum, s) => sum + (s.dishes?.length || 0),
                0
            );
            const today = new Date();
            const currentMonth = today.getMonth();
            const currentYear = today.getFullYear();
            this.monthlyNewCount = this.filteredSuppliers.filter((s) => {
                if (!s.createTime) return false;
                const createDate = new Date(s.createTime);
                return createDate.getMonth() === currentMonth && createDate.getFullYear() === currentYear;
            }).length;
        },

        searchSuppliers() {
            this.currentPage = 1;
            this.filteredSuppliers = this.pagedSuppliers.filter((s) => {
                const nameMatch = s.supplierName.includes(this.searchForm.supplierName);
                const statusMatch = !this.searchForm.status || s.status === this.searchForm.status;
                return nameMatch && statusMatch;
            });
        },

        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
        },
        handleCurrentChange(page) {
            this.currentPage = page;
        },
        handleRowClick(row) {
            this.$refs.supplierTable?.toggleRowSelection(row);
        },

        // ---------------------- 供应商表单（新增/编辑） ----------------------
        showAddDialog() {
            this.isEditMode = false;
            this.formVisible = true;
            this.supplierForm = {
                userId: localStorage.getItem("userId"),
                supplierName: "",
                contactInfo: "",
                address: "",
                status: "0"
            };
        },

        showEditDialog(supplier) {
            console.log(supplier);

            this.isEditMode = true;
            this.formVisible = true;
            this.supplierForm = {
                ...supplier,  // 复制原有属性
                userId: localStorage.getItem("userId")  // 赋值userId，覆盖或新增该属性
            };
        },

        saveSupplier() {
            this.$refs.basicForm.validate((valid) => {
                if (valid) {
                    const apiMethod = this.isEditMode ? edit : add;
                    apiMethod(this.supplierForm)
                        .then((response) => {
                            if (response.code === 200) {
                                this.$message.success(this.isEditMode ? "更新成功" : "新增成功");
                                this.formVisible = false;
                                this.getList();
                            } else {
                                this.$message.error(`操作失败：${response.message}`);
                            }
                        })
                        .catch(() => {
                            this.$message.error("网络错误，请重试");
                        });
                }
            });
        },


        // ---------------------- 物料管理 ----------------------
        handleShowAddDish(supplierId) {
            this.currentSupplierId = supplierId;
            this.supplierForm.dishes = [];
            this.addDishItem();
            this.addDishVisible = true;
        },

        handleShowAddDish1(supplierId) {
            getSupplyMaterials({ userId: localStorage.getItem('userId'), supplierId: supplierId })
                .then(response => {
                    this.Listdish = response.data || [];
                    this.detailDrawerVisible = true;
                })
                .catch(error => {
                    console.error("获取物料列表失败:", error);
                    this.$message.error("获取物料失败，请重试");
                });
        },

        addDishItem() {
            this.supplierForm.dishes.push({
                bomName: "",
                unit: "",
                price: null,
                imageUrl: ""
            });
            this.dishLocalFiles.push(null);
        },

        removeDishItem(index) {
            if (this.supplierForm.dishes[index].imageUrl) {
                URL.revokeObjectURL(this.supplierForm.dishes[index].imageUrl);
            }
            this.supplierForm.dishes.splice(index, 1);
            this.dishLocalFiles.splice(index, 1);
        },



        Close() {
            this.viewQualificationVisible = false;
            this.getList();
        },



        formatStatus(status) {
            return status === "0" ? "合作中" : "已终止";
        },

        previewImage(url, title) {
            this.previewImageUrl = url;
            this.previewImageTitle = title;
            this.previewImageVisible = true;
        },

        previewDishPhoto(url) {
            this.previewPhotoUrl = url;
            this.previewPhotoVisible = true;
        }
    }
};
</script>


<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>